// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__22gkz","name":"ConsentHeader_name__1xobF","birthday":"ConsentHeader_birthday__2_3gW","skeleton":"ConsentHeader_skeleton__3JdAi"};